export type CebiaEquipmentCredentials = {
  username: string;
  password: string;
};
